import request from "@/utils/request";
import { ElMessage } from "element-plus";

export default {
  name: "DataBackup",
  data() {
    return {
      tableData: [],
      loading: false,
      creating: false,
      downloading: null,
      isMobile: window.innerWidth <= 768
    }
  },
  created() {
    this.load();
    window.addEventListener('resize', this.onResize);
  },
  beforeUnmount() {
    window.removeEventListener('resize', this.onResize);
  },
  methods: {
    onResize() {
      this.isMobile = window.innerWidth <= 768;
    },
    async load() {
      this.loading = true;
      try {
        const res = await request.get('/backup/list');
        if (res.code === '0') {
          this.tableData = (res.data || []).map(item => ({
            ...item,
            tag: this.parseTag(item.fileName),
            tagLabel: this.parseTagLabel(item.fileName),
            timeLabel: this.parseTime(item.fileName)
          }));
        } else {
          ElMessage({ message: res.msg || '获取备份列表失败', type: 'error' });
        }
      } catch (e) {
        ElMessage({ message: '获取备份列表失败', type: 'error' });
      } finally {
        this.loading = false;
      }
    },
    parseTag(fileName) {
      if (fileName.includes('manual')) return 'manual';
      if (fileName.includes('daily')) return 'daily';
      if (fileName.includes('before_deploy') || fileName.includes('prod_backup')) return 'baseline';
      return 'auto';
    },
    parseTagLabel(fileName) {
      const map = { manual: '手动备份', daily: '每日备份', baseline: '部署基线', auto: '自动备份' };
      return map[this.parseTag(fileName)] || '自动备份';
    },
    tagType(tag) {
      const map = { manual: 'primary', daily: 'success', baseline: 'warning', auto: 'info' };
      return map[tag] || 'info';
    },
    // 从文件名解析时间戳 backup_20260927215744_xxx.tar.gz / prod_backup_20260927215744_before_deploy.tar_xxx.gz
    parseTime(fileName) {
      const m = fileName.match(/(\d{14})/);
      if (!m) return '-';
      const s = m[1];
      return `${s.slice(0,4)}-${s.slice(4,6)}-${s.slice(6,8)} ${s.slice(8,10)}:${s.slice(10,12)}:${s.slice(12,14)}`;
    },
    async handleCreate() {
      this.creating = true;
      try {
        const res = await request.post('/backup/create');
        if (res.code === '0') {
          ElMessage({ message: res.msg || '备份成功', type: 'success', duration: 3000 });
          await this.load();
        } else {
          ElMessage({ message: res.msg || '备份失败', type: 'error', duration: 4000 });
        }
      } catch (e) {
        ElMessage({ message: '备份失败', type: 'error' });
      } finally {
        this.creating = false;
      }
    },
    async handleDownload(row) {
      this.downloading = row.key;
      try {
        const res = await request.get('/backup/download', { params: { key: row.key } });
        if (res.code === '0' && res.data && res.data.url) {
          // 跨域签名 URL 必须用 fetch + blob 下载
          const resp = await fetch(res.data.url);
          const blob = await resp.blob();
          const blobUrl = window.URL.createObjectURL(blob);
          const link = document.createElement('a');
          link.href = blobUrl;
          link.download = row.fileName;
          link.click();
          window.URL.revokeObjectURL(blobUrl);
        } else {
          ElMessage({ message: res.msg || '生成下载链接失败', type: 'error' });
        }
      } catch (e) {
        ElMessage({ message: '下载失败', type: 'error' });
      } finally {
        this.downloading = null;
      }
    }
  }
}
